import { ISPEnvironment } from './environment.interface';

export const environment = {
  production: true,
  sentry: '__SENTRY_RELEASE__',
} as ISPEnvironment;
